<div [class]="{'lua-overlay': true, 'above-all': forceAboveAll}" (click)="handleClick($event)">
  <ng-content></ng-content>
</div>
